import { render, staticRenderFns } from "./PrincipalUserDetail.vue?vue&type=template&id=225644f2&scoped=true"
import script from "./PrincipalUserDetail.vue?vue&type=script&lang=js"
export * from "./PrincipalUserDetail.vue?vue&type=script&lang=js"
import style0 from "./PrincipalUserDetail.vue?vue&type=style&index=0&id=225644f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225644f2",
  null
  
)

export default component.exports